// extracted by mini-css-extract-plugin
export var banner = "_ex-0";
export var closeButton = "_ex-2";
export var greenCheckmark = "_ex-3";
export var hereLink = "_ex-4";
export var titleIcon = "_ex-1";